var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7477 12.6465H13.8477V33.5465H34.7477V12.6465Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9004 20.1751L26.858 21.5431L28.3628 20.4487V28.3831H30.0044V17.9863H28.6364L25.9004 20.1751Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3001 22.8551C23.8939 22.3098 24.2625 21.5536 24.2625 20.7186C24.2625 19.0589 22.8061 17.709 21.0163 17.709C19.4944 17.709 18.1929 18.6675 17.8528 20.0393L19.427 20.4393C19.5837 19.8085 20.2516 19.3506 21.0163 19.3506C21.9112 19.3506 22.6399 19.9643 22.6399 20.7186C22.6399 21.4729 21.9112 22.0866 21.0163 22.0866H20.0692V23.7282H21.0163C22.0433 23.7282 22.9097 24.4416 22.9097 25.2862C22.9097 26.145 22.087 26.8442 21.0752 26.8442C20.1613 26.8442 19.3804 26.2647 19.2569 25.4971L17.6543 25.7593C17.9032 27.3135 19.3738 28.4858 21.0743 28.4858C22.9809 28.4858 24.5323 27.0503 24.5323 25.2862C24.5323 24.3143 24.0535 23.4422 23.3001 22.8551Z",
    fill: "#1E88E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7977 40.1967H14.7977L13.8477 36.3967L14.7977 32.5967H33.7977L34.7477 36.3967L33.7977 40.1967Z",
    fill: "#FBC02D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5988 33.5465L41.3988 32.5965V13.5965L37.5988 12.6465L33.7988 13.5965V32.5965L37.5988 33.5465Z",
    fill: "#4CAF50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8012 13.6L34.7512 9.8L33.8012 6H10.0512C8.47702 6 7.20117 7.27585 7.20117 8.85V32.6L11.0012 33.55L14.8012 32.6V13.6H33.8012Z",
    fill: "#1E88E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7988 32.5967V40.1967L41.3988 32.5967H33.7988Z",
    fill: "#E53935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5488 6H33.7988V13.6H41.3988V8.85C41.3988 7.27585 40.123 6 38.5488 6Z",
    fill: "#1565C0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0512 40.1967H14.8012V32.5967H7.20117V37.3467C7.20117 38.9208 8.47702 40.1967 10.0512 40.1967Z",
    fill: "#1565C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.7ec68da6.svg";
export { ForwardRef as ReactComponent };